const STORAGE_KEY = "__risa_logger_namespaces";

let enabledPatterns: string[] = ["*"];
let disabledPatterns: string[] = [];

function matchesPattern(namespace: string, pattern: string): boolean {
  if (pattern === "*") return true;
  if (pattern.endsWith("*")) {
    return namespace.startsWith(pattern.slice(0, -1));
  }
  return namespace === pattern;
}

export function isNamespaceEnabled(namespace: string): boolean {
  const isDisabled = disabledPatterns.some((p) => matchesPattern(namespace, p));
  if (isDisabled) return false;

  return enabledPatterns.some((p) => matchesPattern(namespace, p));
}

export function enableNamespace(pattern: string): void {
  if (!enabledPatterns.includes(pattern)) {
    enabledPatterns.push(pattern);
  }
  disabledPatterns = disabledPatterns.filter((p) => p !== pattern);
  persistNamespaceFilters();
}

export function disableNamespace(pattern: string): void {
  if (!disabledPatterns.includes(pattern)) {
    disabledPatterns.push(pattern);
  }
  enabledPatterns = enabledPatterns.filter((p) => p !== pattern);
  persistNamespaceFilters();
}

export function getNamespaceFilters(): {
  enabled: string[];
  disabled: string[];
} {
  return {
    enabled: [...enabledPatterns],
    disabled: [...disabledPatterns],
  };
}

export function setNamespaceFilters(
  enabled: string[],
  disabled: string[],
): void {
  enabledPatterns = [...enabled];
  disabledPatterns = [...disabled];
}

function persistNamespaceFilters(): void {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ enabled: enabledPatterns, disabled: disabledPatterns }),
    );
  } catch {
    // localStorage unavailable (SSR, workers, etc.)
  }
}

export function loadPersistedNamespaceFilters(): void {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed.enabled)) enabledPatterns = parsed.enabled;
      if (Array.isArray(parsed.disabled)) disabledPatterns = parsed.disabled;
    }
  } catch {
    // localStorage unavailable or corrupted
  }
}
